import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';
import { IRootScope } from 'IRootScope';

interface IArrowSelectorScope extends angular.IScope {
    pageSize: number;
    selectedRowIndex: number;
    rowsCount: number;
}

class WtArrowSelectorPageController implements angular.IComponentController {

    static $inject = ['$scope', '$rootScope', '$element'];
    constructor(private $scope: IArrowSelectorScope,
        private _$rootScope: IRootScope,
        private _$element: angular.IAugmentedJQuery
    ) { }

    $onInit() {
        if (!this.$scope.pageSize) {
            this.$scope.pageSize = 15;
        }

        let focus: boolean;
        this._$element.on('focusin', (_event) => {
            if (!this._$rootScope.isEditMode) {
                if (!this.$scope.selectedRowIndex) {
                    this.$scope.selectedRowIndex = 0;
                }
                focus = true;
            }
        });
        this._$element.on('focusout', (_event) => {
            if (!this._$rootScope.isEditMode) {
                this.$scope.selectedRowIndex = null;
                focus = false;
            }
        });
        this._$element.on('keydown', (e) => {
            if (focus) {
                const self = this;
                switch (e.keyCode) {
                    case 38:
                        self.execArrowUp(this.$scope, e);
                        break;
                    case 40:
                        self.execArrowDown(this.$scope, e);
                        break;
                    case 33:
                        self.execPageUp(this.$scope, e);
                        break;
                    case 34:
                        self.execPageDown(this.$scope, e);
                        break;
                    case 36:
                        self.execHome(this.$scope, e);
                        break;
                    case 35:
                        self.execEnd(this.$scope, e);
                        break;
                }
            }
        });
    }

    private execArrowUp(scope: IArrowSelectorScope, e: any) {
        if (scope.selectedRowIndex !== 0) {
            scope.selectedRowIndex--;
            this.scrollToRow(scope.selectedRowIndex);
            this.apply(scope, e);
        }
    }

    private execArrowDown(scope: IArrowSelectorScope, e: any) {
        if (scope.selectedRowIndex !== scope.rowsCount - 1) {
            scope.selectedRowIndex++;
            this.scrollToRow(scope.selectedRowIndex);
            this.apply(scope, e);
        }
    }

    private execPageUp(scope: IArrowSelectorScope, e: any) {
        const index = Math.max(0, scope.selectedRowIndex - scope.pageSize);
        scope.selectedRowIndex = index;
        this.scrollToRow(scope.selectedRowIndex);
        this.apply(scope, e);
    }

    private execPageDown(scope: IArrowSelectorScope, e: any) {
        const index = Math.min(scope.selectedRowIndex + scope.pageSize, scope.rowsCount - 1);
        scope.selectedRowIndex = index;
        this.scrollToRow(scope.selectedRowIndex);
        this.apply(scope, e);
    }

    private execHome(scope: IArrowSelectorScope, e: any) {
        scope.selectedRowIndex = 0;
        this.scrollToRow(scope.selectedRowIndex);
        this.apply(scope, e);
    }

    private execEnd(scope: IArrowSelectorScope, e: any) {
        scope.selectedRowIndex = scope.rowsCount - 1;
        this.scrollToRow(scope.selectedRowIndex);
        this.apply(scope, e);
    }

    private apply(scope: angular.IScope, e: any): void {
        scope.$apply();
        e.preventDefault();
    }

    private scrollToRow(index: number): void {
        const row = this._$element.children('tbody').children('tr')[index];
        if (row) {
            row.scrollIntoView(false);
        }
    }
}

export const WtArrowSelectorPageDirective: DirectiveDefinition = {
    directiveId: 'wtArrowSelectorPage',
    restrict: 'A',
    controller: WtArrowSelectorPageController,
    scope: {
        pageSize: '<?',
        selectedRowIndex: '=',
        rowsCount: '<'
    }
};